import { render } from "./MyExpensesTab.vue?vue&type=template&id=6cabc320&scoped=true&ts=true"
import script from "./MyExpensesTab.vue?vue&type=script&lang=ts"
export * from "./MyExpensesTab.vue?vue&type=script&lang=ts"

import "./MyExpensesTab.vue?vue&type=style&index=0&id=6cabc320&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cabc320"]])

export default __exports__